import { render, staticRenderFns } from "./review-header.vue?vue&type=template&id=243554d0"
import script from "./review-header.vue?vue&type=script&lang=ts"
export * from "./review-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports